/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type {
  Signer,
  AddressLike,
  ContractDeployTransaction,
  ContractRunner,
} from "ethers";
import type { NonPayableOverrides } from "../../common";
import type {
  RootNodeController,
  RootNodeControllerInterface,
} from "../../contracts/RootNodeController";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "multisig",
        type: "address",
      },
      {
        internalType: "address",
        name: "superAdmin",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "AccessControlBadConfirmation",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "neededRole",
        type: "bytes32",
      },
    ],
    name: "AccessControlUnauthorizedAccount",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
    ],
    name: "AddressEmptyCode",
    type: "error",
  },
  {
    inputs: [],
    name: "FailedInnerCall",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
    ],
    name: "RootNodeControllerAbsenceOfResolver",
    type: "error",
  },
  {
    inputs: [],
    name: "RootNodeControllerAccessProhibited",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "admin",
        type: "address",
      },
    ],
    name: "RemoveControllerAdmin",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "admin",
        type: "address",
      },
    ],
    name: "SetControllerAdmin",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "registry",
        type: "address",
      },
    ],
    name: "SetRegistry",
    type: "event",
  },
  {
    inputs: [],
    name: "ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MULTISIG_SUPER_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "SUPER_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "caller",
        type: "address",
      },
    ],
    name: "isAuthorized",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes[]",
        name: "data",
        type: "bytes[]",
      },
    ],
    name: "multicall",
    outputs: [
      {
        internalType: "bytes[]",
        name: "results",
        type: "bytes[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "admin",
        type: "address",
      },
    ],
    name: "removeAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "callerConfirmation",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "newAddr",
        type: "address",
      },
    ],
    name: "setAddr",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "admin",
        type: "address",
      },
    ],
    name: "setAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "newBaseURI",
        type: "string",
      },
    ],
    name: "setBaseURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "uint64",
        name: "expiration",
        type: "uint64",
      },
    ],
    name: "setExpiration",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "string",
        name: "newName",
        type: "string",
      },
    ],
    name: "setName",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "setOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "resolver",
        type: "address",
      },
    ],
    name: "setRecord",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "registrar",
        type: "address",
      },
      {
        internalType: "bool",
        name: "status",
        type: "bool",
      },
    ],
    name: "setRegistrar",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_registry",
        type: "address",
      },
    ],
    name: "setRegistry",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "resolver",
        type: "address",
      },
    ],
    name: "setResolver",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "label",
        type: "bytes32",
      },
      {
        internalType: "uint64",
        name: "expiration",
        type: "uint64",
      },
    ],
    name: "setSubnodeExpiration",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "label",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "setSubnodeOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "label",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "resolver",
        type: "address",
      },
    ],
    name: "setSubnodeRecord",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type RootNodeControllerConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: RootNodeControllerConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class RootNodeController__factory extends ContractFactory {
  constructor(...args: RootNodeControllerConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    multisig: AddressLike,
    superAdmin: AddressLike,
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(multisig, superAdmin, overrides || {});
  }
  override deploy(
    multisig: AddressLike,
    superAdmin: AddressLike,
    overrides?: NonPayableOverrides & { from?: string }
  ) {
    return super.deploy(multisig, superAdmin, overrides || {}) as Promise<
      RootNodeController & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): RootNodeController__factory {
    return super.connect(runner) as RootNodeController__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): RootNodeControllerInterface {
    return new Interface(_abi) as RootNodeControllerInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): RootNodeController {
    return new Contract(address, _abi, runner) as unknown as RootNodeController;
  }
}
